export const useCartStore = defineStore('cart', () => {
  const { $axios } = useNuxtApp()
  const progressbarStore = useProgressbarStore()
  const { showSnackbar } = useSnackbarStore()
  const appConfigStore = useAppConfigStore()
  const appConfig = appConfigStore.appConfig

  const isLoading = ref(false)
  const cartData = ref(null)
  const cartItemCount = ref(0)

  // >> computed
  const cartItemTotal = computed(() => cartItemListWithTotals.value?.reduce((sum, item) => sum + item.subtotal, 0))
  const cartItemListWithTotals = computed(() => {
    return cartData.value?.cartItemList?.map((item) => {
      const styleColorKey = p.getStyleColorKey(item)
      const totalQty = g.sumArray(item.qtyList)
      const subtotal = totalQty * item.price1
      const isActive = item.status == 'ACTIVE'
      return {
        ...item,
        isActive,
        styleColorKey,
        totalQty,
        subtotal
      }
    })
  })

  // >> method
  const initCart = () => {
    isLoading.value = false
    cartData.value = null
    //addToCartData.value = []
    cartItemCount.value = 0
  }
  const addToCart = async (cartItemList) => {
    let isSuccessful = false
    progressbarStore.showLoading()
    try {
      const response = await $axios.post(useApi().cartApi.CART_ADD, cartItemList)
      if (response.header.isSuccessful) {
        refreshCartItemCount()
        //console.log('add to cart response data', response.data)
        //if (!response.data) showSnackbar(new Error(`The style '${productNo}' could not be found.`))
        isSuccessful = true
      }
    } catch (e) {
      showSnackbar(e)
    }
    setTimeout(() => {
      progressbarStore.hideLoading()
    }, 100)
    return isSuccessful
  }
  const _getCartItemGrandTotal = () =>
    cartData.value?.cartItemList?.reduce((total, item) => {
      return total + g.sumArray(item.qtyList)
    }, 0)

  const getCart = async (withLoading = true) => {
    progressbarStore.showLoading()
    if (withLoading) isLoading.value = true
    try {
      const response = await $axios.get(useApi().cartApi.CART)
      if (response.header.isSuccessful) {
        cartData.value = response.data
        cartItemCount.value = _getCartItemGrandTotal()
      }
    } catch (e) {
      showSnackbar(e)
    }
    if (withLoading) isLoading.value = false
    setTimeout(() => {
      progressbarStore.hideLoading()
    }, 100)
  }
  const updateCartItem = async (cartItem) => {
    progressbarStore.showLoading()
    //isLoading.value = true
    let isSuccessful = false
    try {
      const param = {
        cartItemNo: cartItem.cartItemNo,
        style: cartItem.style,
        color: cartItem.color,
        po: cartItem.po,
        qtys: cartItem.qtyList
      }
      const response = await $axios.put(useApi().cartApi.CART, param)
      if (response.header.isSuccessful) {
        await getCart(false)
        isSuccessful = true
      }
    } catch (e) {
      showSnackbar(e)
    }
    //isLoading.value = false
    setTimeout(() => {
      progressbarStore.hideLoading()
    }, 100)
    return isSuccessful
  }
  const deleteCartItem = async (cartItem) => {
    progressbarStore.showLoading()
    //isLoading.value = true
    try {
      const param = {
        cartItemNo: cartItem.cartItemNo,
        style: cartItem.style,
        color: cartItem.color
      }
      const response = await $axios.delete(useApi().cartApi.CART, { data: param })
      if (response.header.isSuccessful) {
        await getCart(false)
      }
    } catch (e) {
      showSnackbar(e)
    }
    //isLoading.value = false
    setTimeout(() => {
      progressbarStore.hideLoading()
    }, 100)
  }
  const refreshCartItemCount = async () => {
    try {
      const response = await $axios.get(useApi().cartApi.CART_COUNT)
      if (response.header.isSuccessful) {
        cartItemCount.value = response.data
      }
    } catch (e) {
      showSnackbar(e)
    }
  }
  const getOrderModelForConfirmPopup = (orderModel, minValue = appConfig.web.confirmPopupThresholdQty) => {
    //console.log('>getOrderModelForConfirmPopup', orderModel)
    if (minValue == 0) return []
    return Object.entries(orderModel)
      .filter(([_, value]) => value >= minValue)
      .map(([key, value]) => {
        const parts = key.split('|')
        if (parts.length !== 3) return null

        const [styleNo, colorCode, sizeName] = parts
        return {
          styleNo: styleNo,
          colorCode: colorCode,
          sizeName: sizeName,
          qty: value
        }
      })
      .filter(Boolean)
  }
  return {
    initCart,
    addToCart,
    getCart,
    updateCartItem,
    deleteCartItem,
    refreshCartItemCount,
    getOrderModelForConfirmPopup,
    isLoading,
    cartData,
    //addToCartData,
    cartItemCount,
    cartItemTotal,
    cartItemListWithTotals
  }
})
